export default __webpack_public_path__ + "src/images/packages/qambathi-mountain-lodge/c536c46469537933a4025ec8987ca33b-1.jpg";